<template>
  <loginLayout>
    <div class="login-panl">
      <div style="text-align: center">
        <h1 class="title">云创空间 · 用户注册</h1>
      </div>
      <div class="f-wrapper">
        <Input
          class="login-input"
          placeholder="请输入手机号码/邮箱"
          clearable
          v-model="form.name"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <div class="flex-content-between login-pswd">
          <Input
            class="login-input"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
            style="width: 350px"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon3.png"
                alt=""
              />
            </template>
          </Input>
          <Button
              ref="smsBtn"
              class="sms-btn"
              shape="circle"
              height="60px"
              @click="refreshCode"
              :disabled="codeDisabled"
              style="width: 120px"
          >{{text1}}</Button>
        </div>
        <Input
          class="login-input login-pswd"
          placeholder="请输入密码"
          type="password"
          clearable
          v-model="form.password"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <Input
          class="login-input login-pswd"
          placeholder="请再次输入密码"
          type="password"
          clearable
          v-model="form.confirmPassword"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <div style="margin-top: 20px">
          <Checkbox v-model="agreement" class="color-000 c-check"
            >我已阅读并同意遵守</Checkbox
          >
          <span class="color-000 pointer" @click="agreementModel"
            >《用户服务协议》</span
          >
          <span class="color-000 pointer" @click="privacyModel"
            >《隐私政策》</span
          >
        </div>
        <div style="position: relative">
          <Button
            class="login-btn"
            style="
              bordr: 1px solid #73bd77;
              background: #73bd77;
              color: #fff;
              width: 70%;
            "
            shape="circle"
            long
            :loading="loading"
            @click="submit"
            >立即注册</Button
          >
          <router-link class="link" to="/login">
            <span>已有账户，</span>
            <span style="color: #73bd77">立即登录</span></router-link
          >
        </div>
      </div>
    </div>
    <!-- 云创空间服务协议 -->
    <rule-modal
      :show.sync="agreementModelShow"
      :content="agreementRuleContent"
      :title="agreementTitle"
    ></rule-modal>
    <!-- 隐私政策 -->
    <rule-modal
      :show.sync="privacyModelShow"
      :content="privacyRuleContent"
      :title="privacyRuleTitle"
    ></rule-modal>
    <div>
      <layout></layout>
    </div>
    <Modal
        v-model="verifyshow"
        title="验证码"
        @on-ok="getCodeEvent"
        @on-cancel="verifyshow = false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
    </Modal>
  </loginLayout>
</template>

<script>
import loginLayout from "./components/loginLayout.vue";
import layout from "../home/components/layout.vue";
import { getEncrypt } from "utils/encrypt";
import { getRegisterCode, register } from "api/customer.js";
import ruleModal from "components/ruleModal.vue";
import agreement from "assets/rule/agreementRule";
import privacyRule from "assets/rule/privacyRule";
import { API_BASE_URL } from "@/utils/config";

export default {
  name: "userReg",
  components: {
    loginLayout,
    ruleModal,
    layout,
  },
  data() {
    return {
      agreement: false,
      form: {
        name: "",
        password: "",
        code: "",
        confirmPassword: "",
      },
      loading: false,
      // 云创空间服务协议
      agreementModelShow: false,
      agreementRuleContent: "",
      agreementTitle: "",
      // 隐私政策
      privacyModelShow: false,
      privacyRuleContent: "",
      privacyRuleTitle: "",
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号/邮箱不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}/gsweb/sms/register/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    agreementModel() {
      this.agreementModelShow = true;
      if (!this.agreementRuleContent) {
        this.agreementRuleContent = agreement.content;
        this.agreementTitle = agreement.title;
      }
    },
    privacyModel() {
      this.privacyModelShow = true;
      if (!this.privacyRuleContent) {
        this.privacyRuleContent = privacyRule.content;
        this.privacyRuleTitle = privacyRule.title;
      }
    },
    // 获取验证码
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码/邮箱！");
        this.$refs.smsBtn.reset();
        return;
      }
      getRegisterCode(this.form.name, this.codeValue )
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.text1 = `${i--}秒后再获取`;
            this.codeDisabled = true
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text1 = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text1 = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
        });
    },
    // 提交
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入手机号码/邮箱！");
        return false;
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码/邮箱！");
        return false;
      }
      if (!this.form.code) {
        this.$Message.warning("请输入验证码！");
        return false;
      }
      if (!this.form.password) {
        this.$Message.warning("请输入密码！");
        return false;
      }
      if (!this.form.confirmPassword) {
        this.$Message.warning("请再次输入密码！");
        return false;
      } else if (this.form.password !== this.form.confirmPassword) {
        this.$Message.warning("两次密码不正确！");
        return false;
      }
      if (!this.agreement) {
        this.$Message.warning("请仔细阅读并同意协议！");
        return false;
      }
      const data = {
        source: 1,
        siteUrl: "http://domain.yc0597.com/",
        pwd: getEncrypt(this.form.password),
        npwd: getEncrypt(this.form.confirmPassword),
        phone: this.form.name,
        msg: this.form.code,
      };
      this.loading = true;
      register(data)
        .then((res) => {
          this.loading = false;
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("注册成功！");
            this.$router.replace("/login");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.login-panl {
  display: block;
  width: 506px;
  // height: 380px;
  background-color: #fff;
  margin: 50px auto 137px;
  // top: 50%;
  // left: 50%;
  // margin-left: -15%;
  // transform: translateY(-50%);
  // padding: 30px 63px 125px;
  .link {
    // line-height: 50px;
    font-weight: 600;
    color: #000000;
    padding-top: 25px;
    font-size: 14px;
    right: 0px;
    position: absolute;
    bottom: 15px;
  }
  .title {
    font-size: 22px;
    line-height: 50px;
    font-weight: bold;
    color: #000;
  }
  .f-wrapper {
    margin-top: 10px;
    .login-name {
      margin-top: 22px;
    }
    .login-pswd {
      margin-top: 30px;
    }
    .login-name2 {
      margin-top: 18px;
    }
    .f-link {
      color: #999999;
    }
    .sms-check {
      cursor: pointer;
      color: #ff5c35;
      font-weight: 400;
    }
  }
  /deep/.c-check {
    .ivu-checkbox {
      margin-right: 10px;
    }
    color: #000;
  }
  /deep/.login-btn {
    margin-top: 40px;
    height: 50px;
    font-size: 14px;
    font-weight: 400;
  }
  /deep/.login-input {
    .ivu-input {
      height: 50px !important;
      line-height: 50px !important;
      border-radius: 30px;
      padding: 0 30px 0 50px !important;
      font-size: 16px;
      font-weight: 400;
      line-height: 50px;
    }

    .ivu-input-prefix {
      padding-left: 20px;
      width: auto;
      line-height: 50px;
    }
    .ivu-input-icon-clear {
      line-height: 50px;
      font-size: 24px;
    }
  }
  /deep/.ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #73bd77 !important;
    background-color: #73bd77 !important;
  }
}
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
::v-deep .ivu-modal-content {
  background-color: #fff!important;
}
.sms-btn /deep/ {
  .ivu-btn {
    width: 100%;
    height: 100%;
    background-color: #F85A36;
    color: #fff;
    &:hover{
      border-color: #F85A36;
    }
  }
}
</style>
